module.exports = __webpack_public_path__ + "img/shetab-first-page.3341c0f1.png";